var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "section" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("Header", _vm._b({}, "Header", _vm.$route.meta, false)),
          _c("div", { staticClass: "columns" }, [
            _c(
              "div",
              { staticClass: "column is-9" },
              [
                _c("ag-grid-vue", {
                  staticClass: "ag-theme-alpine",
                  staticStyle: { width: "100%", height: "700px" },
                  attrs: {
                    "row-data": _vm.scans,
                    "grid-options": _vm.gridOptions,
                    pagination: true,
                    "animate-rows": true,
                    "get-child-count": _vm.getChildCount,
                    "pagination-auto-page-size": true,
                    "get-context-menu-items": _vm.getContextMenuItems,
                    "detail-row-height": 200,
                    "multi-sort-key": "ctrl",
                    modules: _vm.modules,
                  },
                  on: { "grid-ready": _vm.gridReady },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isMaterialModalActive,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isMaterialModalActive = $event
            },
          },
        },
        [
          _c("div", { staticClass: "modal-card" }, [
            _c("header", { staticClass: "modal-card-head" }, [
              _c("p", { staticClass: "modal-card-title" }, [
                _vm._v(" " + _vm._s(_vm.$t("global.materials")) + " "),
              ]),
            ]),
            _c(
              "section",
              { staticClass: "modal-card-body" },
              [
                _c(
                  "b-field",
                  { attrs: { grouped: "" } },
                  [
                    _c(
                      "b-field",
                      [
                        _c("b-input", {
                          attrs: {
                            placeholder: "Search...",
                            type: "search",
                            icon: "search",
                          },
                          model: {
                            value: _vm.searchMaterial,
                            callback: function ($$v) {
                              _vm.searchMaterial = $$v
                            },
                            expression: "searchMaterial",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { type: "is-info", "icon-left": "file-csv" },
                            on: { click: _vm.exportMaterials },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("global.export")) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-table",
                  {
                    attrs: {
                      "per-page": 15,
                      data: _vm.filteredMaterials,
                      loading: _vm.isLoading,
                      narrowed: "",
                      striped: "",
                      paginated: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function (props) {
                          return [
                            _c("span", [_vm._v(_vm._s(props.column.label))]),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c("b-table-column", {
                      attrs: {
                        field: "barcode",
                        label: _vm.$t("global.barcode"),
                        sortable: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm._v(" " + _vm._s(props.row.barcode) + " "),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("b-table-column", {
                      attrs: {
                        field: "scannedAt",
                        label: _vm.$t("pages.scans.scanned_at"),
                        sortable: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    new Date(
                                      props.row.scannedAt
                                    ).toLocaleString()
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("template", { slot: "bottom-left" }, [
                      _c("b", [_vm._v(_vm._s(_vm.$t("global.total")))]),
                      _vm._v(": " + _vm._s(_vm.filteredMaterials.length) + " "),
                    ]),
                    _c("template", { slot: "empty" }, [_c("nothing-here")], 1),
                  ],
                  2
                ),
              ],
              1
            ),
            _c("footer", { staticClass: "modal-card-foot" }),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }